// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlueButtonComponentIcon {
    max-width: 14px;
    filter: brightness(0) invert(1);
}

.BlueButtonComponent {
    padding: 10px;
    width: 200px;
    background-color: transparent;
    background-repeat: no-repeat;
    border: 2px solid var(--BlueButtonComponentBorderColor);
    border-radius: var(--BlueButtonComponentBorderRadius);
    color: var(--BlueButtonComponentTextColor);
    font-weight: 800;
    text-transform: uppercase;
    font-family: var(--googleFont);
}

.BlueButtonComponent:hover {
    padding: 10px;
    width: 200px;
    background-color: var(--BlueButtonComponentBorderColor);
    border: 2px solid var(--BlueButtonComponentBorderColor);
    border-radius: var(--BlueButtonComponentBorderRadius);
    color: var(--topbarColor);

    cursor: pointer;
}

.BlueButtonComponentHidden {
    display: none;
}

.BlueButtonComponentRed {
    padding: 10px;
    width: 200px;
    background-color: transparent;
    background-repeat: no-repeat;
    border: 2px solid rgb(196, 56, 56);
    border-radius: var(--BlueButtonComponentBorderRadius);
    color: rgb(196, 56, 56);
    font-weight: 800;
    text-transform: uppercase;
    font-family: var(--googleFont);
}

.BlueButtonComponentRed:hover {
    padding: 10px;
    width: 200px;
    background-color: rgb(196, 56, 56);
    border: 2px solid rgb(196, 56, 56);
    border-radius: var(--BlueButtonComponentBorderRadius);
    color: var(--topbarColor);
    cursor: pointer;
}

.BlueButtonComponentHiddenRed {
    display: none;
}

.BlueButtonComponentSmall {
    display: inline-block;
    background-color: var(--BlueButtonSmallBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    min-width: 70px;
    font-family: var(--googleFont);
}

.BlueButtonComponentSmall:active {
    background-color: var(--BlueButtonSmallActive);
}

.BlueButtonComponentSmall:hover {
    cursor: pointer;
}

.BlueButtonComponentSmallGray {
    display: inline-block;
    background-color: var(--BlueButtonSmallBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    opacity: 0.5;
    min-width: 70px;
    font-family: var(--googleFont);
}

.BlueButtonComponentSmallIsBlock {
    display: block;
    background-color: var(--BlueButtonSmallBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    min-width: 70px;
    margin-left: auto;
    margin-right: auto;
    font-family: var(--googleFont);
}

.BlueButtonComponentSmallIsBlock:active {
    background-color: var(--BlueButtonSmallActive);
}

.BlueButtonComponentSmallIsBlock:hover {
    cursor: pointer;
}

.BlueButtonComponentSmallGrayIsBlock {
    display: block;
    background-color: var(--BlueButtonSmallBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    opacity: 0.5;
    min-width: 70px;
    margin-left: auto;
    margin-right: auto;
    font-family: var(--googleFont);
}

.DarkerBlueButtonComponent {
    display: inline-block;
    background-color: var(--DarkBlueButtonBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    min-width: 70px;
    font-family: var(--googleFont);
}

.DarkerBlueButtonComponent:hover {
    cursor: pointer;
}

.DarkerBlueButtonComponentGray {
    display: inline-block;
    background-color: var(--DarkBlueButtonBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    opacity: 0.5;
    min-width: 70px;
    font-family: var(--googleFont);
}

.DarkerBlueButtonComponentIsBlock {
    display: block;
    background-color: var(--DarkBlueButtonBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    min-width: 70px;
    margin-left: auto;
    margin-right: auto;
    font-family: var(--googleFont);
}

.DarkerBlueButtonComponentIsBlock:active {
    background-color: var(--DarkBlueButtonActive);
}

.DarkerBlueButtonComponentIsBlock:hover {
    cursor: pointer;
}

.DarkerBlueButtonComponentGrayIsBlock {
    display: block;
    background-color: var(--DarkBlueButtonBackground);
    border-radius: 4px;
    border: none;
    color: white;
    margin: 0px 1px;
    padding: 8px;
    opacity: 0.5;
    min-width: 70px;
    margin-left: auto;
    margin-right: auto;
    font-family: var(--googleFont);
}

@media only screen and (max-width: 768px) {
    .BlueButtonComponent {
        padding: 10px;
        width: 140px;
        font-size: 11px;
        background-color: transparent;
        background-repeat: no-repeat;
        border: 2px solid var(--BlueButtonComponentBorderColor);
        border-radius: var(--BlueButtonComponentBorderRadius);
    }

    .BlueButtonComponent:hover {
        padding: 10px;
        width: 140px;
        font-size: 11px;
        background-color: var(--BlueButtonComponentBorderColor);
        border: 2px solid var(--BlueButtonComponentBorderColor);
        border-radius: var(--BlueButtonComponentBorderRadius);
    }

    .BlueButtonComponentRed {
        padding: 10px;
        width: 140px;
        font-size: 11px;
        background-color: transparent;
        background-repeat: no-repeat;
        border: 2px solid rgb(196, 56, 56);
        border-radius: var(--BlueButtonComponentBorderRadius);
        color: rgb(196, 56, 56);
    }

    .BlueButtonComponentRed:hover {
        padding: 10px;
        width: 140px;
        font-size: 11px;
        background-color: rgb(196, 56, 56);
        border: 2px solid rgb(196, 56, 56);
        border-radius: var(--BlueButtonComponentBorderRadius);
        color: var(--BlueButtonComponentTextColor);
    }
}

@media only screen and (max-width: 320px) {
    .BlueButtonComponentSmall {
        transform: scale(0.8);
    }

    .DarkerBlueButtonComponent {
        transform: scale(0.8);
    }

    .DarkerBlueButtonComponentGray {
        transform: scale(0.8);
    }

    .DarkerBlueButtonComponentIsBlock {
        transform: scale(0.8);
    }

    .BlueButtonComponentSmallIsBlock {
        transform: scale(0.8);
    }

    .BlueButtonComponentSmallGray {
        transform: scale(0.8);
    }

    .DarkerBlueButtonComponentIsBlock {
        transform: scale(0.8);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueButton/BlueButton.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,4BAA4B;IAC5B,uDAAuD;IACvD,qDAAqD;IACrD,0CAA0C;IAC1C,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uDAAuD;IACvD,uDAAuD;IACvD,qDAAqD;IACrD,yBAAyB;;IAEzB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,4BAA4B;IAC5B,kCAAkC;IAClC,qDAAqD;IACrD,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kCAAkC;IAClC,kCAAkC;IAClC,qDAAqD;IACrD,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kDAAkD;IAClD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,6BAA6B;QAC7B,4BAA4B;QAC5B,uDAAuD;QACvD,qDAAqD;IACzD;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,uDAAuD;QACvD,uDAAuD;QACvD,qDAAqD;IACzD;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,6BAA6B;QAC7B,4BAA4B;QAC5B,kCAAkC;QAClC,qDAAqD;QACrD,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,eAAe;QACf,kCAAkC;QAClC,kCAAkC;QAClC,qDAAqD;QACrD,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".BlueButtonComponentIcon {\n    max-width: 14px;\n    filter: brightness(0) invert(1);\n}\n\n.BlueButtonComponent {\n    padding: 10px;\n    width: 200px;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    border: 2px solid var(--BlueButtonComponentBorderColor);\n    border-radius: var(--BlueButtonComponentBorderRadius);\n    color: var(--BlueButtonComponentTextColor);\n    font-weight: 800;\n    text-transform: uppercase;\n    font-family: var(--googleFont);\n}\n\n.BlueButtonComponent:hover {\n    padding: 10px;\n    width: 200px;\n    background-color: var(--BlueButtonComponentBorderColor);\n    border: 2px solid var(--BlueButtonComponentBorderColor);\n    border-radius: var(--BlueButtonComponentBorderRadius);\n    color: var(--topbarColor);\n\n    cursor: pointer;\n}\n\n.BlueButtonComponentHidden {\n    display: none;\n}\n\n.BlueButtonComponentRed {\n    padding: 10px;\n    width: 200px;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    border: 2px solid rgb(196, 56, 56);\n    border-radius: var(--BlueButtonComponentBorderRadius);\n    color: rgb(196, 56, 56);\n    font-weight: 800;\n    text-transform: uppercase;\n    font-family: var(--googleFont);\n}\n\n.BlueButtonComponentRed:hover {\n    padding: 10px;\n    width: 200px;\n    background-color: rgb(196, 56, 56);\n    border: 2px solid rgb(196, 56, 56);\n    border-radius: var(--BlueButtonComponentBorderRadius);\n    color: var(--topbarColor);\n    cursor: pointer;\n}\n\n.BlueButtonComponentHiddenRed {\n    display: none;\n}\n\n.BlueButtonComponentSmall {\n    display: inline-block;\n    background-color: var(--BlueButtonSmallBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    min-width: 70px;\n    font-family: var(--googleFont);\n}\n\n.BlueButtonComponentSmall:active {\n    background-color: var(--BlueButtonSmallActive);\n}\n\n.BlueButtonComponentSmall:hover {\n    cursor: pointer;\n}\n\n.BlueButtonComponentSmallGray {\n    display: inline-block;\n    background-color: var(--BlueButtonSmallBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    opacity: 0.5;\n    min-width: 70px;\n    font-family: var(--googleFont);\n}\n\n.BlueButtonComponentSmallIsBlock {\n    display: block;\n    background-color: var(--BlueButtonSmallBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    min-width: 70px;\n    margin-left: auto;\n    margin-right: auto;\n    font-family: var(--googleFont);\n}\n\n.BlueButtonComponentSmallIsBlock:active {\n    background-color: var(--BlueButtonSmallActive);\n}\n\n.BlueButtonComponentSmallIsBlock:hover {\n    cursor: pointer;\n}\n\n.BlueButtonComponentSmallGrayIsBlock {\n    display: block;\n    background-color: var(--BlueButtonSmallBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    opacity: 0.5;\n    min-width: 70px;\n    margin-left: auto;\n    margin-right: auto;\n    font-family: var(--googleFont);\n}\n\n.DarkerBlueButtonComponent {\n    display: inline-block;\n    background-color: var(--DarkBlueButtonBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    min-width: 70px;\n    font-family: var(--googleFont);\n}\n\n.DarkerBlueButtonComponent:hover {\n    cursor: pointer;\n}\n\n.DarkerBlueButtonComponentGray {\n    display: inline-block;\n    background-color: var(--DarkBlueButtonBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    opacity: 0.5;\n    min-width: 70px;\n    font-family: var(--googleFont);\n}\n\n.DarkerBlueButtonComponentIsBlock {\n    display: block;\n    background-color: var(--DarkBlueButtonBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    min-width: 70px;\n    margin-left: auto;\n    margin-right: auto;\n    font-family: var(--googleFont);\n}\n\n.DarkerBlueButtonComponentIsBlock:active {\n    background-color: var(--DarkBlueButtonActive);\n}\n\n.DarkerBlueButtonComponentIsBlock:hover {\n    cursor: pointer;\n}\n\n.DarkerBlueButtonComponentGrayIsBlock {\n    display: block;\n    background-color: var(--DarkBlueButtonBackground);\n    border-radius: 4px;\n    border: none;\n    color: white;\n    margin: 0px 1px;\n    padding: 8px;\n    opacity: 0.5;\n    min-width: 70px;\n    margin-left: auto;\n    margin-right: auto;\n    font-family: var(--googleFont);\n}\n\n@media only screen and (max-width: 768px) {\n    .BlueButtonComponent {\n        padding: 10px;\n        width: 140px;\n        font-size: 11px;\n        background-color: transparent;\n        background-repeat: no-repeat;\n        border: 2px solid var(--BlueButtonComponentBorderColor);\n        border-radius: var(--BlueButtonComponentBorderRadius);\n    }\n\n    .BlueButtonComponent:hover {\n        padding: 10px;\n        width: 140px;\n        font-size: 11px;\n        background-color: var(--BlueButtonComponentBorderColor);\n        border: 2px solid var(--BlueButtonComponentBorderColor);\n        border-radius: var(--BlueButtonComponentBorderRadius);\n    }\n\n    .BlueButtonComponentRed {\n        padding: 10px;\n        width: 140px;\n        font-size: 11px;\n        background-color: transparent;\n        background-repeat: no-repeat;\n        border: 2px solid rgb(196, 56, 56);\n        border-radius: var(--BlueButtonComponentBorderRadius);\n        color: rgb(196, 56, 56);\n    }\n\n    .BlueButtonComponentRed:hover {\n        padding: 10px;\n        width: 140px;\n        font-size: 11px;\n        background-color: rgb(196, 56, 56);\n        border: 2px solid rgb(196, 56, 56);\n        border-radius: var(--BlueButtonComponentBorderRadius);\n        color: var(--BlueButtonComponentTextColor);\n    }\n}\n\n@media only screen and (max-width: 320px) {\n    .BlueButtonComponentSmall {\n        transform: scale(0.8);\n    }\n\n    .DarkerBlueButtonComponent {\n        transform: scale(0.8);\n    }\n\n    .DarkerBlueButtonComponentGray {\n        transform: scale(0.8);\n    }\n\n    .DarkerBlueButtonComponentIsBlock {\n        transform: scale(0.8);\n    }\n\n    .BlueButtonComponentSmallIsBlock {\n        transform: scale(0.8);\n    }\n\n    .BlueButtonComponentSmallGray {\n        transform: scale(0.8);\n    }\n\n    .DarkerBlueButtonComponentIsBlock {\n        transform: scale(0.8);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
